import { trigger, transition, style, animate } from "@angular/animations";

export const LEAD_BASED_PAINT = {
    'course': 
    {
        'icon':'business_center'
    },
    'endorsement':
    {
        'icon':'how_to_vote'
    },
    'credential':
    {
        'icon':'card_membership'
    },
    'certificate':
    {
        'icon':'receipt'
    },
    'firm':
    {
        'icon':'business',
        'color':'#86D6C0',        
    },
    'individual':
    {
        'icon':'recent_actors',
        'color':'#ACA2D0',
    },
    'atp':
    {
        'icon':'school',
        'color':'#628ef4',
    },
    'lbpa':
    {
        'icon':'store_mall_directory',
        'color':'#ffbe2e',        
    },
    'rrp':
    {
        'icon':'build',
        'color':'#EC891D',        
    },
    'complaint':
    {
        'icon':'comment',
        'color':'#ff685d'
    },
    'payment':
    {
        'icon':'attach_money'
    },
    'apply':
    {
        'icon':'book'
    },
    'staff':
    {
        'icon':'people'
    },
    'address':
    {
        'icon':'location_on'
    },
    'contact':
    {
        'icon':'contact_mail'
    },
    'name':
    {
        'icon':'label'
    },
    'id':
    {
        'icon':'info'
    },
    'calendar':
    {
        'icon':'event'
    },
    'training':
    {
        'icon':'fitness_center'
    },
    'testing':
    {
        'icon':'playlist_add_check'
    },
    'notes': 
    {
        'icon':'notes'
    },
};

export const APPLICATION_STATUS = {    
    cancelled: "Cancelled",
    inProgress: "In Progress",
    submitted: "Submitted",    
    inReview: "In Review",
    actionNeeded: "Action Needed",    
    approved: "Approved",
}

export const FIRM_SERVICES = {
    inspections: "Inspections",
    riskAssessments: "Risk Assessments",
    clearanceTesting: "Clearance Testing",
    leadHazardScreening: "Lead Hazard Screening",
    abatement: "Abatement",
}

export const FIRM_SERVICE_FOR = {
    internal: "Internal Only",
    residential: "Residential",
    commercial: "Commercial",
    both: "Both Residential and Commercial",
    non: "Non-Residential",
    unk: "Unknown",
}

export const FIRM_APPLICATION_TYPES = {
    rrp: "rrp",
    lbpa: "lbpa",
    link: "link"
}

export const FIRM_CERTIFICATE_ATTENTION_FILTERS = {
    expiring: "Expiring",
    expired: "Expired",
}

export const DISCIPLINE_CODES = {
    inspector: {code:'I', display:'Inspector'},
    projectDesigner: {code:'D', display:'Project Designer'},
    riskAssessor: {code:'R', display:'Risk Assessor'},
    supervisor: {code:'S', display:'Supervisor'},
    worker: {code:'W', display:'Worker'},
}

export const STUDENT_CODE_TYPES = {
    worker: 'Worker',
    supervisor: 'Supervisor',
    projectDesigner: 'Project Designer',
    riskAssessor: 'Risk Assessor',
    rrpRenovator: 'RRP Renovator',
    inspector: 'Inspector',
    dustSamplingTech: 'Dust Sampling Technician',
}

export const COURSE_TYPE = {
    standard: 'Standard',
    refresher: 'Refresher'
}

export const COURSE_DISCIPLINES = {
    dustSamplingTechnician: 'Dust Sampling Technician',
    inspector: 'Inspector',    
    projectDesigner: 'Project Designer',
    renovator: 'Renovator',
    renovatorHands: 'Renovator (Hands On)',
    riskAssessor: 'Risk Assessor',
    supervisor: 'Supervisor',
    worker: 'Worker',    
}

export const COURSE_TYPES = {
    initial: "Initial",
    refresher: "Refresher",      
}

export const COURSE_FORMAT = {
    inPerson: "In Person",
    videoConferenceLecture: "Videoconference Lecture",  
    handsOnExam: "Hands On/Exam",
    online: "Online",
    hybrid: "Hybrid",
}

export const COURSE_LANGUAGE = {
    english: "English",
    espanol: "Espanol",  
    other: "Other",
}

export const APPLICATION_TYPES = {    
    firstaccreditation: 'First Accreditation',
    addaccreditation: 'Accreditation',
    reaccreditation: 'Reaccreditation',
    ammendment: 'Ammendment',
    link: 'Account Link',
};

export const ACCEPTED_FILE_TYPES = {
    extensions: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.zip', '.xls', '.xlsx'],
    displayText: 'PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, ZIP, XLS, XLSX'
};

export const ANIMATIONS = [
    trigger('slideLeft', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))
      ])
    ]),
    trigger('slideRight', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    
  ];